enum MODALS {
    CookieConsent = "CookieConsent",
    ShareItem = "ShareItem",
    ChangePassword = "ChangePassword",
    Approve = "Approve",
    EditUser = "EditUser",
}

export default MODALS;
